import ProductCard from "components/ProductCard";
import ShimmerNewProducts from "components/shimmer/ShimmerNewProducts";
import useNewProducts from "hook/useNewProduct";
import { useEffect, useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const NewProducts = () => {
  const { newProducts, loading1 } = useNewProducts();
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);


  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const timer = setTimeout(checkScroll, 100);
    window.addEventListener("resize", checkScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkScroll);
    };
  }, [newProducts]);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
  };

  if (loading1) {
    return <ShimmerNewProducts />;
  }

  if (!loading1 && newProducts.length === 0) {
    return null;
  }

  return (
    <section className="sm:mt-10 mt-6 px-4 sm:px-6">
      <div className="rounded-lg bg-slate-900 p-4 text-white">
        <div className="flex items-center justify-between pb-3">
          <div>
            <h3 className="text-xl font-extrabold sm:text-2xl">New Products</h3>
            <p className="text-sm text-slate-300 sm:text-base">
              Just landed this week.
            </p>
          </div>
          <Link
            type="button"
            to="/allNewProduct"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-3 py-2 text-xs font-semibold text-white transition hover:bg-white/15 sm:text-sm"
          >
            View All
            <FaArrowRight />
          </Link>
        </div>
        <div className="flex snap-x gap-3 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            {newProducts
              .filter((item) => item.hideStatus === "available")
              .map((item) => (
                <ProductCard
                  key={item.id}
                  item={item}
                  bgClass="bg-white/10"
                  cartColor="text-white"
                  currencyClass="text-amber-300"
                  textColor="text-white"
                />
              ))}
          </div>
      </div>
    </section>
  );
};

export default NewProducts;
